export const getIsLandScapeOrientation = () => {
  const angle = screen?.orientation?.angle || window.orientation;
  return angle === 90 || angle === -90;
};
